import { Checkbox } from '@/components/ui/checkbox';

interface CheckboxCellEditorProps {
  value: unknown;
  onChange: (value: boolean) => void;
}

/**
 * Checkbox editor - toggles on click (no separate edit mode needed)
 */
export function CheckboxCellEditor({ value, onChange }: CheckboxCellEditorProps) {
  const checked = value === true || value === 'true' || value === 1;

  return (
    <div className="flex items-center justify-center h-full">
      <Checkbox
        checked={checked}
        onCheckedChange={(val) => onChange(val === true)}
        className="data-[state=checked]:bg-success data-[state=checked]:border-success"
      />
    </div>
  );
}
